import React from 'react';
import logo from '../images/fastSeoCopy_logo.png';
import WalletBadge from './WalletBadge';

export default function Header({
    onLogoClick,
    showMenuButton = false,
    onMenuClick,
    menuOpen = false,
}) {
    const handleLogoClick = () => {
        if (onLogoClick) {
            onLogoClick();
        }
    };

    return (
        <div className="Header">
            <header>
                <div className="header-left">
                    {showMenuButton && (
                        <button
                            type="button"
                            className={`header-nav-toggle${menuOpen ? ' is-open' : ''}`}
                            onClick={onMenuClick}
                            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                            aria-expanded={menuOpen}
                            aria-controls="app-sidebar"
                        >
                            <span className="header-nav-toggle__bar" />
                            <span className="header-nav-toggle__bar" />
                            <span className="header-nav-toggle__bar" />
                        </button>
                    )}
                </div>

                <div className="logo-link" onClick={handleLogoClick} style={{ cursor: 'pointer', justifySelf: 'center' }}>
                    <img src={logo} className="Header-logo" alt="AITrend SEO Logo" />
                </div>

                <div className="header-right" style={{ justifySelf: 'end' }}>
                    <WalletBadge />
                </div>
            </header>
        </div>
    );
}
